import React from 'react';
import Clearfix from 'components/elements/clearfix';
import { Tab, Tabs } from '@blueprintjs/core';
import PageBuilding from 'components/pageBuilding'
import DanhMucPanel from './DanhMucPanel'
import DanhMucHoaChat from './danh-muc-hoa-chat'
import PageLockHOC from 'hoc/pageLock'

const panelList = [
  {
    key: 'danhmuc',
    title: 'Quản lý danh mục'
  },
  {
    key: 'QL_HoaChat',
    title: 'Quản lý loại chất thải'
  },

];

@PageLockHOC(['manage.full'])
export default class ManagementContainer extends React.Component {
  static propTypes = {};

  state = {};


  renderPanel = keyPanel => {
    switch (keyPanel) {
      case 'danhmuc': {
        return <DanhMucPanel />
      }
      case 'QL_HoaChat': {
        return <DanhMucHoaChat />
      }

      default: {
        return <PageBuilding />;
      }
    }
  };

  componentDidMount() { }

  render() {
    return (
      <div>
        <Clearfix height={16} />
        <Tabs renderActiveTabPanelOnly={true} style={{ color: 'red' }} animate={false}>
          {panelList.map(item => (
            <Tab
              id={item.key}
              key={item.key}
              title={item.title}
              panel={this.renderPanel(item.key)}
            />
          ))}
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ManagementContainer/index.js